import * as React from 'react';
import moment from 'moment';
import { OfferSettingsJsonType } from '@bb/domain/dist/types';

type OfferInformationProps = {
  offerCount: number;
  offerSettings: Pick<
    OfferSettingsJsonType,
    | 'acceptedAnytime'
    | 'offerDate'
    | 'otherInstructions'
    | 'preemptive'
    | 'registration'
    | 'requestIrrevocable'
  >;
  offerSubmissions: string;
};

const OfferInformation: React.FunctionComponent<OfferInformationProps> = ({
  offerCount,
  offerSettings,
  offerSubmissions,
}) => (
    <>
      <h3>Information</h3>
      <hr />
      <h4>Currently {offerCount} Offers Registered</h4>
      <h5>Presentation Date</h5>

      <div>
        {offerSettings.acceptedAnytime
          ? 'Offers accepted anytime.'
          : moment(offerSettings.offerDate).format('MMM D, YYYY H:mm:ss A')}
      </div>

      {offerSubmissions && (
        <div>
          <span>Offers to be presented by: {offerSubmissions}</span>
        </div>
      )}
      {offerSettings.requestIrrevocable && (
        <div>
          <h5>Request Irrevocable</h5>
          <span>{offerSettings.requestIrrevocable} hours</span>
        </div>
      )}
      {offerSettings.otherInstructions && (
        <div>
          <h5>Other Instructions</h5>
          <span>{offerSettings.otherInstructions}</span>
        </div>
      )}
    </>
  );

export default OfferInformation;
